import {ApplicationEntity} from "@/model/entity/application-entity"
import {FieldDescriptor, FieldTypeEnum} from "@/model/entity//field-descriptor"
import {Exclude} from "class-transformer"

export class Language extends ApplicationEntity {
  @FieldDescriptor({fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.language.key"})
  key: string
  @FieldDescriptor({
    fieldType: FieldTypeEnum.SELECT,
    fieldPrettyName: "entity.language.lang",
    columnWidth: "100",
    selectionFieldDescription: {
      values: ["HR", "EN", "SI"],
      i18n: false
    }
  })
  lang: string
  @FieldDescriptor({fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.language.value"})
  value: string

  @Exclude()
  lowerCasedValue?: string

  constructor(
    id?: number,
    key: string = "",
    lang: string = "",
    value: string = ""
  ) {
    super(id)
    this.key = key.toString()
    this.lang = lang.toString()
    this.value = value.toString()
  }
}
